export default __webpack_public_path__ + "static/media/flag-benin.93d1cd96.svg";